/**
 * Mediadept専用のDTP用DTO
 */

export class DtoMdDtp {
  /** */
  public date: string | null = null;
}
